import React, { useEffect } from 'react';

export default function Lightbox({ images = [], index = 0, onClose = () => {}, onNext = () => {}, onPrev = () => {} }) {
  const img = (images && images[index]) || null;

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') onNext();
      if (e.key === 'ArrowLeft') onPrev();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose, onNext, onPrev]);

  if (!img) return null;

  return (
    <div style={styles.overlay} role="dialog" aria-modal="true" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <button aria-label="Fechar" onClick={(e) => { e.stopPropagation(); onClose(); }} style={styles.closeBtn}>✕</button>
      <button aria-label="Anterior" onClick={(e) => { e.stopPropagation(); onPrev(); }} style={styles.leftBtn}>◀</button>
      <div style={styles.content}>
        {img.type && img.type.startsWith('video/') ? (
          <video src={img.url} controls autoPlay style={styles.media} />
        ) : (
          <img src={img.url} alt="visualização" style={styles.media} />
        )}
      </div>
      <button aria-label="Próximo" onClick={(e) => { e.stopPropagation(); onNext(); }} style={styles.rightBtn}>▶</button>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(30,30,30,0.78)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999999999
  },
  content: { maxWidth: '88%', maxHeight: '88%', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  media: { maxWidth: '100%', maxHeight: '100%', borderRadius: 6, boxShadow: '0 8px 30px rgba(0,0,0,0.6)' },
  leftBtn: { position: 'fixed', left: 18, top: '50%', transform: 'translateY(-50%)', fontSize: 28, background: 'transparent', color: '#fff', border: 'none', cursor: 'pointer', zIndex: 9999999999 },
  rightBtn: { position: 'fixed', right: 18, top: '50%', transform: 'translateY(-50%)', fontSize: 28, background: 'transparent', color: '#fff', border: 'none', cursor: 'pointer', zIndex: 9999999999 },
  closeBtn: { position: 'fixed', right: 18, top: 18, fontSize: 18, background: 'rgba(200,200,200,0.18)', color: '#fff', border: 'none', cursor: 'pointer', zIndex: 9999999999, width: 40, height: 40, borderRadius: '50%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }
};
